define('OutSystems/ClientRuntime/DateTime',["require", "exports", "./Format", "./Settings"], function (require, exports, Format_1, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DateTimeConstants = exports.DateTime = void 0;
    function coalesce(a, b) {
        return a === null || a === undefined ? b : a;
    }
    var DEFAULT_YEAR = 1900;
    var DEFAULT_MONTH = 0;
    var DEFAULT_DAY = 1;
    var DEFAULT_HOURS = 0;
    var DEFAULT_MINUTES = 0;
    var DEFAULT_SECONDS = 0;
    var DEFAULT_MILLISECONDS = 0;
    var DEFAULT_WEEKDAY = 1;
    var DateTimeLegacy = (function () {
        function DateTimeLegacy(year, month, day, hours, minutes, seconds, milliseconds) {
            this.isDefaultDate = false;
            if (arguments.length === 0) {
                this.date = this.nativeDefaultDate();
            }
            else if (arguments.length === 1) {
                if (year instanceof Date || Object.prototype.toString.call(year) === "[object Date]") {
                    var nativeDateValue = year.getTime();
                    if (!isNaN(nativeDateValue)) {
                        this.date = new Date(nativeDateValue);
                    }
                    else {
                        this.date = this.nativeDefaultDate();
                    }
                }
                else {
                    this.date = new Date(year);
                }
            }
            else if (coalesce(year, DEFAULT_YEAR) < 100) {
                this.date = new Date(100, 0, 1, 0, 0, 0, 0);
                this.date.setFullYear(coalesce(year, DEFAULT_YEAR));
                this.date.setMonth(coalesce(month, DEFAULT_MONTH + 1) - 1);
                this.date.setDate(coalesce(day, DEFAULT_DAY));
                this.date.setHours(coalesce(hours, DEFAULT_HOURS));
                this.date.setMinutes(coalesce(minutes, DEFAULT_MINUTES));
                this.date.setSeconds(coalesce(seconds, DEFAULT_SECONDS));
                this.date.setMilliseconds(coalesce(milliseconds, DEFAULT_MILLISECONDS));
            }
            else {
                this.date = new Date(coalesce(year, DEFAULT_YEAR), coalesce(month, DEFAULT_MONTH + 1) - 1, coalesce(day, DEFAULT_DAY), coalesce(hours, DEFAULT_HOURS), coalesce(minutes, DEFAULT_MINUTES), coalesce(seconds, DEFAULT_SECONDS), coalesce(milliseconds, DEFAULT_MILLISECONDS));
            }
            this.isDefaultDate =
                !(0, Settings_1.getEnvParams)().NullDatesTZAware &&
                    this.date.getFullYear() === DEFAULT_YEAR &&
                    this.date.getMonth() === DEFAULT_MONTH &&
                    this.date.getDate() === DEFAULT_DAY &&
                    this.date.getHours() === DEFAULT_HOURS &&
                    this.date.getMinutes() === DEFAULT_MINUTES &&
                    this.date.getSeconds() === DEFAULT_SECONDS &&
                    this.date.getMilliseconds() === DEFAULT_MILLISECONDS;
        }
        Object.defineProperty(DateTimeLegacy, "defaultValue", {
            get: function () {
                return DateTimeLegacy.defaultValueField;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "isInvalid", {
            get: function () {
                throw new Error("Not implemented: getIsInvalid");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "getDate", {
            get: function () {
                return this.date;
            },
            enumerable: false,
            configurable: true
        });
        DateTimeLegacy.prototype.nativeDefaultDate = function () {
            return new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, DEFAULT_HOURS, DEFAULT_MINUTES, DEFAULT_SECONDS, DEFAULT_MILLISECONDS);
        };
        Object.defineProperty(DateTimeLegacy.prototype, "isDefault", {
            get: function () {
                return this.isDefaultDate;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "year", {
            get: function () {
                return this.isDefault ? DEFAULT_YEAR : this.date.getFullYear();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "month", {
            get: function () {
                return this.isDefault ? DEFAULT_MONTH + 1 : this.date.getMonth() + 1;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "day", {
            get: function () {
                return this.isDefault ? DEFAULT_DAY : this.date.getDate();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "hours", {
            get: function () {
                return this.isDefault ? DEFAULT_HOURS : this.date.getHours();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "minutes", {
            get: function () {
                return this.isDefault ? DEFAULT_MINUTES : this.date.getMinutes();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "seconds", {
            get: function () {
                return this.isDefault ? DEFAULT_SECONDS : this.date.getSeconds();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "milliseconds", {
            get: function () {
                return this.isDefault ? DEFAULT_MILLISECONDS : this.date.getMilliseconds();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeLegacy.prototype, "weekDay", {
            get: function () {
                return this.isDefault ? DEFAULT_WEEKDAY : this.date.getDay();
            },
            enumerable: false,
            configurable: true
        });
        DateTimeLegacy.prototype.addYears = function (years) {
            var dt = new DateTimeLegacy(this.year + years, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            if (this.month === 2 && this.day === 29 && dt.month === 3) {
                return new DateTimeLegacy(dt.year, 2, 28, dt.hours, dt.minutes, dt.seconds, dt.milliseconds);
            }
            return dt;
        };
        DateTimeLegacy.prototype.daysInMonth = function (month, year) {
            return new Date(year, month, 0).getDate();
        };
        DateTimeLegacy.prototype.addMonths = function (months) {
            var dt = new DateTimeLegacy(this.year, this.month + months, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            if (dt.day === this.day) {
                return dt;
            }
            return new DateTimeLegacy(dt.year, dt.month - 1, this.daysInMonth(dt.month - 1, dt.year), dt.hours, dt.minutes, dt.seconds, dt.milliseconds);
        };
        DateTimeLegacy.prototype.addDays = function (days) {
            return new DateTimeLegacy(this.year, this.month, this.day + days, this.hours, this.minutes, this.seconds, this.milliseconds);
        };
        DateTimeLegacy.prototype.addHours = function (hours) {
            return new DateTimeLegacy(this.year, this.month, this.day, this.hours + hours, this.minutes, this.seconds, this.milliseconds);
        };
        DateTimeLegacy.prototype.addMinutes = function (minutes) {
            return new DateTimeLegacy(this.year, this.month, this.day, this.hours, this.minutes + minutes, this.seconds, this.milliseconds);
        };
        DateTimeLegacy.prototype.addSeconds = function (seconds) {
            return new DateTimeLegacy(this.year, this.month, this.day, this.hours, this.minutes, this.seconds + seconds, this.milliseconds);
        };
        DateTimeLegacy.prototype.addMilliseconds = function (milliseconds) {
            return new DateTimeLegacy(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds + milliseconds);
        };
        DateTimeLegacy.prototype.equals = function (other) {
            return !!other && this.getTime() === other.getTime();
        };
        DateTimeLegacy.prototype.eq = function (other) {
            return this.equals(other);
        };
        DateTimeLegacy.prototype.greaterThan = function (other) {
            return this.date > other.getDate;
        };
        DateTimeLegacy.prototype.gt = function (other) {
            return this.greaterThan(other);
        };
        DateTimeLegacy.prototype.greaterThanOrEqualTo = function (other) {
            return this.date >= other.getDate;
        };
        DateTimeLegacy.prototype.gte = function (other) {
            return this.greaterThanOrEqualTo(other);
        };
        DateTimeLegacy.prototype.lessThan = function (other) {
            return this.date < other.getDate;
        };
        DateTimeLegacy.prototype.lt = function (other) {
            return this.lessThan(other);
        };
        DateTimeLegacy.prototype.lessThanOrEqualTo = function (other) {
            return this.date <= other.getDate;
        };
        DateTimeLegacy.prototype.lte = function (other) {
            return this.lessThanOrEqualTo(other);
        };
        DateTimeLegacy.prototype.toNative = function () {
            return this.isDefault ? this.nativeDefaultDate() : new Date(this.date.getTime());
        };
        DateTimeLegacy.prototype.getTime = function () {
            return this.isDefault ? this.nativeDefaultDate().getTime() : this.date.getTime();
        };
        DateTimeLegacy.prototype.valueOf = function () {
            return this.isDefault ? this.nativeDefaultDate().valueOf() : this.date.valueOf();
        };
        DateTimeLegacy.fromISODate = function (value) {
            var valid = DateTimeConstants.RFC3339_DATEPART.test(value);
            if (valid) {
                return DateTimeLegacy.internalFromUTCWithoutConversion(value + "T00:00:00Z");
            }
            return DateTimeLegacy.defaultValue;
        };
        DateTimeLegacy.prototype.toISODate = function () {
            return this.toString(DateTimeConstants.RFC3339_DATEPART_FORMAT);
        };
        DateTimeLegacy.fromISOTime = function (value) {
            var valid = DateTimeConstants.RFC3339_TIMEPART.test(value);
            if (valid) {
                return DateTimeLegacy.internalFromUTCWithoutConversion("1900-01-01T" + value + "Z");
            }
            return DateTimeLegacy.defaultValue;
        };
        DateTimeLegacy.prototype.toISOTime = function () {
            return this.toString(DateTimeConstants.RFC3339_TIMEPART_FORMAT);
        };
        DateTimeLegacy.fromISODateTime = function (value) {
            value = value || "";
            if (value === "" || (value.indexOf("1900-01-01") >= 0 && value.indexOf("00:00:00") >= 0)) {
                return DateTimeLegacy.defaultValue;
            }
            var rxTimezone = /([+\-]\d{2}((:\d{2})|(\d{2})?)|Z)$/;
            if (value.indexOf("T") > 0 && !rxTimezone.test(value)) {
                return DateTimeLegacy.internalFromUTCWithoutConversion(value.trim() + "Z");
            }
            value = value.replace(/([+-]\d{2})$/, function fun(x) {
                return x + "00";
            });
            var parsedDate = Date.parse(value);
            if (!isNaN(parsedDate)) {
                return new DateTimeLegacy(parsedDate);
            }
            return DateTimeLegacy.defaultValue;
        };
        DateTimeLegacy.internalFromUTCWithoutConversion = function (value) {
            var parsedDate = Date.parse(value);
            if (!isNaN(parsedDate)) {
                var dateInUTC = new Date(parsedDate);
                return new DateTimeLegacy(dateInUTC.getUTCFullYear(), dateInUTC.getUTCMonth() + 1, dateInUTC.getUTCDate(), dateInUTC.getUTCHours(), dateInUTC.getUTCMinutes(), dateInUTC.getUTCSeconds(), dateInUTC.getUTCMilliseconds());
            }
            return DateTimeLegacy.defaultValue;
        };
        DateTimeLegacy.prototype.toDBDateTime = function () {
            throw new Error("Not implemented: toDBDateTime");
        };
        DateTimeLegacy.fromDBDateTime = function (value) {
            throw new Error("Not implemented: fromDBDateTime");
        };
        DateTimeLegacy.prototype.getMillisecondsString = function () {
            return (this.milliseconds / 1000).toFixed(3).substring(2, 5);
        };
        DateTimeLegacy.prototype.toString = function (format) {
            var _this = this;
            if (arguments.length === 0) {
                if (this.equals(DateTimeLegacy.defaultValue)) {
                    return "1900-01-01T00:00:00";
                }
                else {
                    return this.date.toISOString();
                }
            }
            return format.replace(/(\\.)|dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|ff?f?|FF?F?|\.FF?F?|tt?|zz?z?/g, function (f) {
                if (f.indexOf("\\") === 0) {
                    return f.substring(1);
                }
                switch (f) {
                    case "hh":
                    case "h":
                        var normalizedHours = _this.hours < 13 ? _this.hours : _this.hours - 12;
                        return Format_1.DateTimeFormatInfo.padLeadingZeros((_this.hours === 0 ? 12 : normalizedHours).toString(), f.length);
                    case "HH":
                    case "H":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.hours.toString(), f.length);
                    case "mm":
                    case "m":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.minutes.toString(), f.length);
                    case "ss":
                    case "s":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.seconds.toString(), f.length);
                    case "fff":
                        return _this.getMillisecondsString();
                    case "ff":
                        return _this.getMillisecondsString().substring(0, 2);
                    case "f":
                        return _this.getMillisecondsString().substring(0, 1);
                    case ".FFF":
                    case ".FF":
                    case ".F":
                        return _this.milliseconds === 0
                            ? ""
                            : "." + Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString());
                    case "FFF":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString());
                    case "FF":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString()).substring(0, 2);
                    case "F":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString()).substring(0, 1);
                    case "yyyy":
                    case "yyy":
                        var year = _this.year.toString();
                        if (year.charAt(0) === "0") {
                            return _this.year.toString().substring(1);
                        }
                        return year;
                    case "yy":
                        return _this.year.toString().substring(2, 4);
                    case "y":
                        return Number(_this.year.toString().substring(2, 4)).toString();
                    case "dddd":
                        return Format_1.DateTimeFormatInfo.getDayName(_this.weekDay);
                    case "ddd":
                        return Format_1.DateTimeFormatInfo.getShortDayName(_this.weekDay);
                    case "dd":
                    case "d":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.day.toString(), f.length);
                    case "MMMM":
                        return Format_1.DateTimeFormatInfo.getMonthName(_this.month);
                    case "MMM":
                        return Format_1.DateTimeFormatInfo.getShortMonthName(_this.month);
                    case "MM":
                    case "M":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.month.toString(), f.length);
                    case "t":
                        return Format_1.DateTimeFormatInfo.get12HourNotation(_this.hours).substring(0, 1);
                    case "tt":
                        return Format_1.DateTimeFormatInfo.get12HourNotation(_this.hours);
                    case "zzz":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationFull(_this.date.getTimezoneOffset());
                    case "zz":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationHoursFull(_this.date.getTimezoneOffset());
                    case "z":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationHoursShort(_this.date.getTimezoneOffset());
                    default:
                        return f;
                }
            });
        };
        DateTimeLegacy.defaultValueField = new DateTimeLegacy();
        return DateTimeLegacy;
    }());
    var DateTimeNew = (function () {
        function DateTimeNew(year, month, day, hours, minutes, seconds, milliseconds) {
            this.isTimezoneIndependent = false;
            this.invalid = true;
            this.date = null;
            var timestamp;
            if (arguments.length === 0) {
                this.invalid = false;
                return;
            }
            if (arguments.length === 1) {
                if (year instanceof Date || Object.prototype.toString.call(year) === "[object Date]") {
                    timestamp = year.getTime();
                }
                else {
                    timestamp = year;
                }
            }
            else if (arguments.length > 1) {
                var y = coalesce(year, DEFAULT_YEAR);
                if (y >= 100 && y <= 9999) {
                    var mo = coalesce(month, DEFAULT_MONTH + 1) - 1;
                    var d = coalesce(day, DEFAULT_DAY);
                    var h = coalesce(hours, DEFAULT_HOURS);
                    var m = coalesce(minutes, DEFAULT_MINUTES);
                    var s = coalesce(seconds, DEFAULT_SECONDS);
                    var ms = coalesce(milliseconds, DEFAULT_MILLISECONDS);
                    var isNullDate = y === DEFAULT_YEAR && mo === DEFAULT_MONTH && d === DEFAULT_DAY;
                    if (arguments.length === 3 || (arguments.length > 3 && isNullDate)) {
                        this.isTimezoneIndependent = true;
                        timestamp = Date.UTC(y, mo, d, h, m, s, ms);
                    }
                    else {
                        timestamp = new Date(y, mo, d, h, m, s, ms).getTime();
                    }
                }
            }
            if (!isNaN(timestamp)) {
                var minDate = this.nativeDefaultDate(this.isTimezoneIndependent).getTime();
                var maxDate = this.isTimezoneIndependent
                    ? Date.UTC(3000, 11, 31, 23, 59, 59, 0)
                    : new Date(3000, 11, 31, 23, 59, 59, 0).getTime();
                if (timestamp >= minDate && timestamp <= maxDate) {
                    this.date = timestamp !== minDate ? new Date(timestamp) : null;
                    this.invalid = false;
                }
            }
        }
        Object.defineProperty(DateTimeNew, "defaultValue", {
            get: function () {
                return DateTimeNew.defaultValueField;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "isInvalid", {
            get: function () {
                return this.invalid;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "getDate", {
            get: function () {
                return this.toNative();
            },
            enumerable: false,
            configurable: true
        });
        DateTimeNew.prototype.nativeDefaultDate = function (inUtc) {
            if (inUtc === void 0) { inUtc = false; }
            if (inUtc) {
                return new Date(Date.UTC(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, DEFAULT_HOURS, DEFAULT_MINUTES, DEFAULT_SECONDS, DEFAULT_MILLISECONDS));
            }
            return new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, DEFAULT_HOURS, DEFAULT_MINUTES, DEFAULT_SECONDS, DEFAULT_MILLISECONDS);
        };
        Object.defineProperty(DateTimeNew.prototype, "isDefault", {
            get: function () {
                return this.date === null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "year", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_YEAR;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCFullYear();
                }
                return this.date.getFullYear();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "month", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_MONTH + 1;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCMonth() + 1;
                }
                return this.date.getMonth() + 1;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "day", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_DAY;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCDate();
                }
                return this.date.getDate();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "hours", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_HOURS;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCHours();
                }
                return this.date.getHours();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "minutes", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_MINUTES;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCMinutes();
                }
                return this.date.getMinutes();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "seconds", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_SECONDS;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCSeconds();
                }
                return this.date.getSeconds();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "milliseconds", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_MILLISECONDS;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCMilliseconds();
                }
                return this.date.getMilliseconds();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTimeNew.prototype, "weekDay", {
            get: function () {
                if (this.isDefault) {
                    return DEFAULT_WEEKDAY;
                }
                if (this.isTimezoneIndependent) {
                    return this.date.getUTCDay();
                }
                return this.date.getDay();
            },
            enumerable: false,
            configurable: true
        });
        DateTimeNew.prototype.addYears = function (years) {
            var dt = new DateTimeNew(this.year + years, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            if (this.month === 2 && this.day === 29 && dt.month === 3) {
                return new DateTimeNew(dt.year, 2, 28, dt.hours, dt.minutes, dt.seconds, dt.milliseconds);
            }
            return dt;
        };
        DateTimeNew.prototype.daysInMonth = function (month, year) {
            return new Date(year, month, 0).getDate();
        };
        DateTimeNew.prototype.addMonths = function (months) {
            var dt = new DateTimeNew(this.year, this.month + months, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            if (dt.day === this.day) {
                return dt;
            }
            return new DateTimeNew(dt.year, dt.month - 1, this.daysInMonth(dt.month - 1, dt.year), dt.hours, dt.minutes, dt.seconds, dt.milliseconds);
        };
        DateTimeNew.prototype.addDays = function (days) {
            return new DateTimeNew(this.year, this.month, this.day + days, this.hours, this.minutes, this.seconds, this.milliseconds);
        };
        DateTimeNew.prototype.addHours = function (hours) {
            return new DateTimeNew(this.year, this.month, this.day, this.hours + hours, this.minutes, this.seconds, this.milliseconds);
        };
        DateTimeNew.prototype.addMinutes = function (minutes) {
            return new DateTimeNew(this.year, this.month, this.day, this.hours, this.minutes + minutes, this.seconds, this.milliseconds);
        };
        DateTimeNew.prototype.addSeconds = function (seconds) {
            return new DateTimeNew(this.year, this.month, this.day, this.hours, this.minutes, this.seconds + seconds, this.milliseconds);
        };
        DateTimeNew.prototype.addMilliseconds = function (milliseconds) {
            return new DateTimeNew(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds + milliseconds);
        };
        DateTimeNew.prototype.equals = function (other) {
            return !!other && this.getTime() === other.getTime();
        };
        DateTimeNew.prototype.eq = function (other) {
            return this.equals(other);
        };
        DateTimeNew.prototype.greaterThan = function (other) {
            return this.getDate > other.getDate;
        };
        DateTimeNew.prototype.gt = function (other) {
            return this.greaterThan(other);
        };
        DateTimeNew.prototype.greaterThanOrEqualTo = function (other) {
            return this.getDate >= other.getDate;
        };
        DateTimeNew.prototype.gte = function (other) {
            return this.greaterThanOrEqualTo(other);
        };
        DateTimeNew.prototype.lessThan = function (other) {
            return this.getDate < other.getDate;
        };
        DateTimeNew.prototype.lt = function (other) {
            return this.lessThan(other);
        };
        DateTimeNew.prototype.lessThanOrEqualTo = function (other) {
            return this.getDate <= other.getDate;
        };
        DateTimeNew.prototype.lte = function (other) {
            return this.lessThanOrEqualTo(other);
        };
        DateTimeNew.prototype.toNative = function () {
            if (this.isDefault) {
                return this.nativeDefaultDate();
            }
            if (this.isTimezoneIndependent) {
                return new Date(this.year, this.month - 1, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            }
            return new Date(this.date.getTime());
        };
        DateTimeNew.prototype.getTime = function () {
            return this.toNative().getTime();
        };
        DateTimeNew.prototype.valueOf = function () {
            return this.toNative().valueOf();
        };
        DateTimeNew.fromISODate = function (value) {
            var valid = DateTimeConstants.RFC3339_DATEPART.test(value);
            if (valid) {
                return DateTimeNew.internalFromUTCWithoutConversion(value + "T00:00:00Z", true);
            }
            return DateTimeConstants.DEFAULT_DATE;
        };
        DateTimeNew.prototype.toISODate = function () {
            return this.toString(DateTimeConstants.RFC3339_DATEPART_FORMAT);
        };
        DateTimeNew.fromISOTime = function (value) {
            var valid = DateTimeConstants.RFC3339_TIMEPART.test(value);
            if (valid) {
                return DateTimeNew.internalFromUTCWithoutConversion("1900-01-01T" + value + "Z");
            }
            return DateTimeConstants.DEFAULT_TIME;
        };
        DateTimeNew.prototype.toISOTime = function () {
            return this.toString(DateTimeConstants.RFC3339_TIMEPART_FORMAT);
        };
        DateTimeNew.fromISODateTime = function (value) {
            value = value || "";
            if (value === "" || (value.indexOf("1900-01-01") >= 0 && value.indexOf("00:00:00") >= 0)) {
                return DateTimeConstants.DEFAULT_DATETIME;
            }
            var rxTimezone = /([+\-]\d{2}((:\d{2})|(\d{2})?)|Z)$/;
            if (value.indexOf("T") > 0 && !rxTimezone.test(value)) {
                return DateTimeNew.internalFromUTCWithoutConversion(value.trim() + "Z");
            }
            value = value.replace(/([+-]\d{2})$/, function fun(x) {
                return x + "00";
            });
            var parsedDate = Date.parse(value);
            return new DateTimeNew(parsedDate);
        };
        DateTimeNew.internalFromUTCWithoutConversion = function (value, isDate) {
            if (isDate === void 0) { isDate = false; }
            var parsedDate = Date.parse(value);
            var dateInUTC = new Date(parsedDate);
            if (isDate) {
                return new DateTimeNew(dateInUTC.getUTCFullYear(), dateInUTC.getUTCMonth() + 1, dateInUTC.getUTCDate());
            }
            else {
                return new DateTimeNew(dateInUTC.getUTCFullYear(), dateInUTC.getUTCMonth() + 1, dateInUTC.getUTCDate(), dateInUTC.getUTCHours(), dateInUTC.getUTCMinutes(), dateInUTC.getUTCSeconds(), dateInUTC.getUTCMilliseconds());
            }
        };
        DateTimeNew.prototype.toDBDateTime = function () {
            if (this.isDefault) {
                return "1900-01-01 00:00:00";
            }
            var nativeDateTime = this.toNative();
            return (maskValue(nativeDateTime.getUTCFullYear(), "0000") +
                "-" +
                maskValue(nativeDateTime.getUTCMonth() + 1, "00") +
                "-" +
                maskValue(nativeDateTime.getUTCDate(), "00") +
                " " +
                maskValue(nativeDateTime.getUTCHours(), "00") +
                ":" +
                maskValue(nativeDateTime.getUTCMinutes(), "00") +
                ":" +
                maskValue(nativeDateTime.getUTCSeconds(), "00"));
        };
        DateTimeNew.fromDBDateTime = function (value) {
            return DateTimeNew.fromISODateTime(value.replace(" ", "T").trim() + "Z");
        };
        DateTimeNew.prototype.getMillisecondsString = function () {
            return (this.milliseconds / 1000).toFixed(3).substring(2, 5);
        };
        DateTimeNew.prototype.getTimezoneOffset = function () {
            if (this.isDefault) {
                return this.nativeDefaultDate().getTimezoneOffset();
            }
            return this.date.getTimezoneOffset();
        };
        DateTimeNew.prototype.toString = function (format) {
            var _this = this;
            if (arguments.length === 0) {
                if (this.isDefault) {
                    return "1900-01-01T00:00:00";
                }
                else {
                    return this.date.toISOString();
                }
            }
            return format.replace(/(\\.)|dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|ff?f?|FF?F?|\.FF?F?|tt?|zz?z?/g, function (f) {
                if (f.indexOf("\\") === 0) {
                    return f.substring(1);
                }
                switch (f) {
                    case "hh":
                    case "h":
                        var normalizedHours = _this.hours < 13 ? _this.hours : _this.hours - 12;
                        return Format_1.DateTimeFormatInfo.padLeadingZeros((_this.hours === 0 ? 12 : normalizedHours).toString(), f.length);
                    case "HH":
                    case "H":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.hours.toString(), f.length);
                    case "mm":
                    case "m":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.minutes.toString(), f.length);
                    case "ss":
                    case "s":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.seconds.toString(), f.length);
                    case "fff":
                        return _this.getMillisecondsString();
                    case "ff":
                        return _this.getMillisecondsString().substring(0, 2);
                    case "f":
                        return _this.getMillisecondsString().substring(0, 1);
                    case ".FFF":
                    case ".FF":
                    case ".F":
                        return _this.milliseconds === 0
                            ? ""
                            : "." + Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString());
                    case "FFF":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString());
                    case "FF":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString()).substring(0, 2);
                    case "F":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString()).substring(0, 1);
                    case "yyyy":
                    case "yyy":
                        var year = _this.year.toString();
                        if (year.charAt(0) === "0") {
                            return _this.year.toString().substring(1);
                        }
                        return year;
                    case "yy":
                        return _this.year.toString().substring(2, 4);
                    case "y":
                        return Number(_this.year.toString().substring(2, 4)).toString();
                    case "dddd":
                        return Format_1.DateTimeFormatInfo.getDayName(_this.weekDay);
                    case "ddd":
                        return Format_1.DateTimeFormatInfo.getShortDayName(_this.weekDay);
                    case "dd":
                    case "d":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.day.toString(), f.length);
                    case "MMMM":
                        return Format_1.DateTimeFormatInfo.getMonthName(_this.month);
                    case "MMM":
                        return Format_1.DateTimeFormatInfo.getShortMonthName(_this.month);
                    case "MM":
                    case "M":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.month.toString(), f.length);
                    case "t":
                        return Format_1.DateTimeFormatInfo.get12HourNotation(_this.hours).substring(0, 1);
                    case "tt":
                        return Format_1.DateTimeFormatInfo.get12HourNotation(_this.hours);
                    case "zzz":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationFull(_this.getTimezoneOffset());
                    case "zz":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationHoursFull(_this.getTimezoneOffset());
                    case "z":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationHoursShort(_this.getTimezoneOffset());
                    default:
                        return f;
                }
            });
        };
        DateTimeNew.defaultValueField = new DateTimeNew();
        return DateTimeNew;
    }());
    function maskValue(value, mask) {
        var length = mask.length;
        var strValue = value.toString();
        return mask.substr(0, Math.max(0, length - strValue.length)) + strValue;
    }
    var dateTimeRevamp = (0, Settings_1.getEnvParams)().DateTimeRevamp;
    exports.DateTime = dateTimeRevamp ? DateTimeNew : DateTimeLegacy;
    var DateTimeConstants;
    (function (DateTimeConstants) {
        DateTimeConstants.RFC3339_TIMEPART = /^([01][0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9](\.\d+)?)?$/;
        DateTimeConstants.RFC3339_DATEPART = /^\d{4,}-(0\d|1[012])-([0-2]\d|3[01])$/;
        DateTimeConstants.RFC3339_TIMEPART_FORMAT = "HH:mm:ss";
        DateTimeConstants.RFC3339_DATEPART_FORMAT = "yyyy-MM-dd";
        DateTimeConstants.MIN_DATE_VALUE = dateTimeRevamp
            ? new exports.DateTime(DEFAULT_YEAR, DEFAULT_MONTH + 1, DEFAULT_DAY)
            : new exports.DateTime(1753, 1, 1);
        DateTimeConstants.MAX_DATE_VALUE = dateTimeRevamp ? new exports.DateTime(3000, 12, 31) : new exports.DateTime(9999, 12, 31);
        DateTimeConstants.MIN_DATETIME_VALUE = dateTimeRevamp
            ? exports.DateTime.defaultValue
            : new exports.DateTime(1753, 1, 1, 0, 0, 0);
        DateTimeConstants.MAX_DATETIME_VALUE = dateTimeRevamp
            ? new exports.DateTime(3000, 12, 31, 23, 59, 59, 0)
            : new exports.DateTime(9999, 12, 31, 23, 59, 59);
        DateTimeConstants.ISO_DATE_FORMAT_REGEXP = /^\d{4,}-(0\d|1[012])-([0-2]\d|3[01])([T ]\d{2}:\d{2}(:\d{2}(\.\d+)?(([+\-]\d{2}((:\d{2})|(\d{2})?))|Z)?)?)?$/i;
        DateTimeConstants.DEFAULT_DATETIME = exports.DateTime.defaultValue;
        DateTimeConstants.DEFAULT_DATE = dateTimeRevamp
            ? new exports.DateTime(DEFAULT_YEAR, DEFAULT_MONTH + 1, DEFAULT_DAY)
            : exports.DateTime.defaultValue;
        DateTimeConstants.DEFAULT_TIME = dateTimeRevamp
            ? new exports.DateTime(DEFAULT_YEAR, DEFAULT_MONTH + 1, DEFAULT_DAY, DEFAULT_HOURS, DEFAULT_MINUTES, DEFAULT_SECONDS)
            : exports.DateTime.defaultValue;
    })(DateTimeConstants || (exports.DateTimeConstants = DateTimeConstants = {}));
});
//# sourceMappingURL=DateTime.js.map;
